import { gridEntries } from '@/mocks/home';

export default function MixedGrid() {
  const lead = gridEntries[0];
  const rest = gridEntries.slice(1);

  return (
    <section id="grid" className="w-full bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="text-[11px] tracking-[0.3em] text-secondary-700 mb-3">本期档案</div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              大小条目混在一起排
            </h2>
          </div>
          <a
            href="#entry"
            className="flex items-center gap-1.5 text-sm text-primary-600 whitespace-nowrap hover:text-primary-700 cursor-pointer"
          >
            按时间查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <a
          href="#entry"
          className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-6 mb-6 cursor-pointer transition-colors hover:border-primary-300"
        >
          <div className="lg:col-span-7 w-full h-[240px] md:h-[360px] rounded-md overflow-hidden bg-background-200">
            <img
              src={lead.image}
              alt="私拍吃瓜放大 封面条目"
              title="私拍吃瓜放大 细节条目"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
            />
          </div>
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-900 text-[11px] tracking-wider">
                {lead.tag}
              </span>
              <span className="text-[11px] tracking-wider text-foreground-500">{lead.span}</span>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950 mb-4">
              {lead.title}
            </h3>
            <p className="text-sm leading-relaxed text-foreground-600 mb-6">{lead.excerpt}</p>
            <div className="flex items-center gap-5 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                {lead.time}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-eye-line"></i>
                </span>
                {lead.reads}
              </span>
            </div>
          </div>
        </a>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((item) => (
            <a
              key={item.id}
              href="#entry"
              className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-colors hover:border-primary-300"
            >
              <div className="w-full h-[180px] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={`私拍吃瓜${item.tag} 条目`}
                  title={`私拍吃瓜${item.tag} 细节`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px] tracking-wider">
                    {item.tag}
                  </span>
                  <span className="text-[11px] tracking-wider text-foreground-500">{item.span}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600 mb-5 flex-1">{item.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-500 pt-4 border-t border-background-200/70">
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    {item.reads}
                  </span>
                </div>
              </div>
            </a>
          ))}

          <a
            href="#entry"
            className="group flex flex-col items-center justify-center gap-3 min-h-[240px] rounded-lg border border-dashed border-background-300 bg-background-50/60 text-foreground-700 cursor-pointer transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-100 border border-background-200">
              <i className="ri-archive-line text-xl"></i>
            </span>
            <span className="text-sm">更多细节档案</span>
            <span className="text-[11px] tracking-wider text-foreground-500">共 312 条 · 按时间排序</span>
          </a>
        </div>
      </div>
    </section>
  );
}